export const EMPTY_TITLE_CRUMB = ' ';